module.exports = __webpack_public_path__ + "static/img/female-bg-pt.70ad570f.png";